import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ReactComponent as InfoIcon } from "images/info-icon.svg";
import styles from "./returnButton.module.css";
import { CustomButton } from "ui";
import { ReturnTokensModal } from "./ReturnTokensModal";

export const ReturnTokensButton = observer(() => {
  const { actionModals } = useStores();

  const handleReturnTokens = async () => {
    actionModals.open(() => <ReturnTokensModal />, {
      width: "700px",
      noValidation: true,
      title: "Проверить баланс по неизвестному токену",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
      onClose: () => actionModals.closeAll(),
    });
  };

  return (
    <CustomButton
      tooltip="Проверить баланс для другого токена"
      type="link"
      size="middle"
      onClick={handleReturnTokens}
      className={styles.syncButton}
    >
      <InfoIcon />
    </CustomButton>
  );
});
